export const token = 'Df6d7yuJDHQPsAgpdUhQ32Zn';

export const license = 'C601B03A-EB254C58-AE1028BA-92AB56E6'

// export const headers = { Authorization: `bearer ${token}` };

export const headers = { Authorization: `bearer ${token}` };

export const api_url = 'https://cors-anywhere.herokuapp.com/https://api.acesaudi.org';

// export const api_url = 'https://api.acesaudi.org';

// export const api_url = 'https://cors-anywhere.herokuapp.com/http://138.197.73.234';

export const baseUrl = `https://cors-anywhere.herokuapp.com/https://us8.api.mailchimp.com/3.0`;

// export const baseUrl = `https://us8.api.mailchimp.com/3.0`;

export const list_id = 'e60ef936a8';

export const mail_token = 'aa43860755a89c4657c6809d9b454936-us8';